
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire305e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire305e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jPxhr", function(module, exports) {

$parcel$export(module.exports, "formatPhoneNumber", () => $e6fc98820934cce0$export$842dcfa371c6bb83);
$parcel$export(module.exports, "formatPhone", () => $e6fc98820934cce0$export$10c09b2cff9813eb);
function $e6fc98820934cce0$export$842dcfa371c6bb83(inputField) {
    const phoneNumber = inputField.value.replace(/[^0-9]/g, ''); // clean the input
    const phoneNumberLength = phoneNumber.length;
    if (phoneNumberLength < 4) return phoneNumber; // no formatting for less than 4 digits
    if (phoneNumberLength < 7) return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
}
function $e6fc98820934cce0$export$10c09b2cff9813eb(phoneNumberString) {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) return '(' + match[1] + ') ' + match[2] + '-' + match[3];
    return null;
}

});

parcelRegister("8sein", function(module, exports) {

$parcel$export(module.exports, "getMetaCookies", () => $627c0708f7a440b6$export$5b7842791614f379);
// facebookClientUtils.js
function $627c0708f7a440b6$export$5b7842791614f379() {
    const cookies = document.cookie.split(';').map((c)=>c.trim());
    const getCookieValue = (name)=>{
        const cookie = cookies.find((c)=>c.startsWith(`${name}=`));
        return cookie ? cookie.split('=')[1] : null;
    };
    const fbp = getCookieValue('_fbp');
    const fbc = getCookieValue('_fbc');
    const userAgent = navigator.userAgent;
    return {
        fbp: fbp,
        fbc: fbc,
        userAgent: userAgent
    };
}

});

parcelRegister("3hjfy", function(module, exports) {

$parcel$export(module.exports, "hashString", () => $2631e4411d47d1f4$export$9169be2e06c9c165);
$parcel$export(module.exports, "hashPhone", () => $2631e4411d47d1f4$export$16844b2dd22651be);
async function $2631e4411d47d1f4$var$sha256(value) {
    const encoder = new TextEncoder();
    const data = encoder.encode(value);
    const hashBuffer = await crypto.subtle.digest("SHA-256", data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map((b)=>b.toString(16).padStart(2, "0")).join("");
}
async function $2631e4411d47d1f4$export$9169be2e06c9c165(txt) {
    if (!txt) return null;
    const normalized = txt.trim().toLowerCase();
    return await $2631e4411d47d1f4$var$sha256(normalized);
}
async function $2631e4411d47d1f4$export$16844b2dd22651be(phone) {
    if (!phone) return null;
    let digits = phone.replace(/\D/g, "");
    if (digits.length === 10) digits = "1" + digits;
    return await $2631e4411d47d1f4$var$sha256(digits);
}

});


var $03cFT = parcelRequire("03cFT");

var $kcvY9 = parcelRequire("kcvY9");

var $cxph1 = parcelRequire("cxph1");

var $jPxhr = parcelRequire("jPxhr");

var $e0Vla = parcelRequire("e0Vla");

var $7FrCY = parcelRequire("7FrCY");

var $bGxh7 = parcelRequire("bGxh7");

var $8sein = parcelRequire("8sein");

var $3hjfy = parcelRequire("3hjfy");
"use strict";
window.Webflow ||= [];
window.Webflow.push(async ()=>{
    // MARK - DEFINE ELEMENTS
    const currentUser = (0, $03cFT.default).User.current();
    if (currentUser != null && currentUser.get('anonymous') == false) (0, $cxph1.goToNextPage)('/');
    const progressModal = document.getElementById('progressModal');
    const topLabel = document.getElementById('topLabel');
    const firstNameField = document.getElementById("createAccountFirstNameField");
    const lastNameField = document.getElementById("createAccountLastNameField");
    const phoneField = document.getElementById("createAccountPhoneTextField");
    const emailFIeld = document.getElementById("createAccountEmailFIeld");
    const passwordField = document.getElementById("createAccountPasswordField");
    const confirmPasswordField = document.getElementById("createAccountConfirmPasswordField");
    const referralTextField = document.getElementById('referralTextField');
    const referValidImageView = document.getElementById('referValidImageView');
    const checkBox = document.getElementById("createAccountCheckBox");
    const createAccountFormButton = document.getElementById("createAccountFormButton");
    // MARK: - REFERRAL / OFFER
    var referralid;
    var initialoffer;
    var initialamount;
    const locationObject = await (0, $kcvY9.LocationObject)();
    const referid = sessionStorage.getItem('referid');
    if (referid != null) {
        referralTextField.value = referid;
        referralid = referid;
        initialoffer = null;
        await loadRefferalUser(referid);
    }
    async function loadRefferalUser(referid) {
        const user = await (0, $03cFT.default).Cloud.run('loadUser', {
            "userid": referid
        });
        const firstname = user.get('firstname');
        referralid = user.id;
        initialamount = locationObject.get('initialreferdiscount');
        topLabel.innerText = 'EARN REFERRAL OFFER FROM YOUR FRIEND ' + firstname.toUpperCase();
        referValidImageView.style.display = 'block';
    }
    /*
    const initial = sessionStorage.getItem('initialoffer');
	if (initial != null) {
        referralid = null;
        initialoffer = initial;
		initialamount = locationObject.get('initialamount');
        referralTextField.value = 'Welcome' + initialamount;
        topLabel.innerText = 'EARN WELCOME ' + initialamount + '% OFFER';
        referralTextField.disabled = true;
	}*/ const offer = sessionStorage.getItem('offer');
    if (offer != null) {
        referralTextField.value = offer.toUpperCase();
        if (offer == "Welcome15") {
            referralid = null;
            initialoffer = offer;
            initialamount = 15;
            referralTextField.value = 'Welcome' + initialamount;
            topLabel.innerText = 'EARN WELCOME ' + initialamount + '% OFFER';
            referralTextField.disabled = true;
        }
        if (offer == "freepizza") {
            referralid = null;
            initialoffer = null;
            topLabel.innerText = 'CLAIM YOUR FREE PIZZA';
            referralTextField.disabled = true;
        }
    }
    // MARK: - DISABLE FORM
    $("#createAccountForm").submit(()=>{
        return false;
    });
    // MARK: - PHONE INPUT
    phoneField.addEventListener('keydown', ()=>{
        const formattedValue = (0, $jPxhr.formatPhoneNumber)(phoneField);
        phoneField.value = formattedValue;
    });
    phoneField.addEventListener('input', (e)=>{
        const phone = phoneField.value;
        if (phone.length > 14) phoneField.value = phone.substring(0, 14);
    });
    referralTextField.addEventListener('input', async (e)=>{
        const referralId = referralTextField.value;
        if (referralId.length > 10) referralTextField.value = referralId.substring(0, 10);
        await updateReferInput(referralId);
    });
    async function updateReferInput(referid) {
        if (referid.length == 10) await loadRefferalUser(referid);
        else {
            referralid = null;
            initialoffer = null;
            referValidImageView.style.display = 'none';
            topLabel.innerText = 'JOIN TO EARN FREE REWARDS AND CHECK OUT FASTER';
        }
    }
    // MARK: - BUTTON ACTIONS
    createAccountFormButton.addEventListener('click', async ()=>{
        const firstName = firstNameField.value;
        const lastName = lastNameField.value;
        const phone = phoneField.value.replace(/\D/g, '');
        const email = emailFIeld.value;
        const password = passwordField.value;
        const confirmPassword = confirmPasswordField.value;
        const error = verifyCreateAccountInfo(firstName, lastName, phone, email, password, confirmPassword);
        if (error != '') alert(error);
        else createAccount(firstName, lastName, phone, email, password);
    });
    // MARK: - CREATE ACCOUNT
    function verifyCreateAccountInfo(firstName, lastName, phone, email, password, confirmPassword) {
        var error = '';
        if (password != confirmPassword) error = 'Passwords do not match';
        if (password.length <= 6) error = 'Password must contain more than 6 characters';
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
        if (!emailRegex.test(email)) error = 'Enter a valid email addres';
        if (phone.length != 10) error = '10 digit phone is required';
        if (lastName == '') error = 'Last name is required';
        if (firstName == '') error = 'First name is required';
        return error;
    }
    async function createAccount(firstName, lastName, phone, email, password) {
        var device = "web";
        if (window.AndroidApp) device = "android";
        const funnel = (0, $bGxh7.getFunnel)();
        const joinComs = checkBox.checked;
        const userData = {
            'firstName': firstName,
            'lastName': lastName,
            'phoneNumber': phone,
            'email': email,
            'password': password,
            'joinComs': joinComs,
            'locationid': (0, $kcvY9.default),
            "device": device,
            "funnel": funnel
        };
        progressModal.style.display = 'flex';
        try {
            const newUser = await (0, $03cFT.default).Cloud.run('createUserAccount', userData);
            const sessionToken = newUser.get('sessionToken');
            await (0, $03cFT.default).User.become(sessionToken);
            if (window.AndroidApp && window.AndroidApp.setUserId) AndroidApp.setUserId(newUser.id);
            //signUpAnalytics(newUser);
            if (offer != null) {
                if (offer == "freepizza") (0, $cxph1.goToNextPage)("/free-pizza");
                if (offer == "Welcome15") (0, $cxph1.goToNextPage)("/download-app");
            } else (0, $cxph1.goToNextPage)('/profile');
        /*
            if (referralid != null || initialoffer != null) {
                setUpPhoneVerify(phone);
            } else {
                goToNextPage('/profile');
            }*/ } catch (e) {
            alert(e.message);
        }
        progressModal.style.display = 'none';
    }
    async function signUpAnalytics(newUser) {
        (0, $7FrCY.logEvent)((0, $e0Vla.default), 'sign_up', {
            method: 'Email'
        });
        const funnel = (0, $bGxh7.getFunnel)();
        const eventId = (0, $bGxh7.generateEventId)();
        const hashedFN = await (0, $3hjfy.hashString)(newUser.get("firstname"));
        const hashedLN = await (0, $3hjfy.hashString)(newUser.get("lastname"));
        const hashedEmail = await (0, $3hjfy.hashString)(newUser.get("email"));
        const hashedPhone = await (0, $3hjfy.hashPhone)(newUser.get("phonenumber"));
        const hashedId = await (0, $3hjfy.hashString)(newUser.id);
        fbq('track', 'CompleteRegistration', {
            funnel_id: funnel.funnelId,
            utm_campaign: funnel.utm_campaign,
            fbclid: funnel.fbclid,
            registration_method: 'Email',
            platform: 'website',
            fn: hashedFN ?? undefined,
            ln: hashedLN ?? undefined,
            em: hashedEmail ?? undefined,
            ph: hashedPhone ?? undefined,
            external_id: hashedId ?? undefined
        }, {
            eventID: eventId
        });
        const { fbp: fbp, fbc: fbc, userAgent: userAgent } = (0, $8sein.getMetaCookies)();
        const customData = {
            registration_method: 'Email',
            platform: 'website'
        };
        const userData = {
            userAgent: userAgent,
            fbp: fbp,
            fbc: fbc
        };
        const request = {
            customData: customData,
            userData: userData,
            funnel: funnel,
            eventId: eventId
        };
        await (0, $03cFT.default).Cloud.run('fbCompleteRegister', request);
    }
    // MARK: - VERIFY PHONE
    const verifyModal = document.getElementById('verifyModal');
    const verifyTopLabel = document.getElementById('verifyTopLabel');
    const verifyPhoneTextField = document.getElementById('verifyPhoneTextField');
    const resendCodeButton = document.getElementById('resendCodeButton');
    const verifySmsButton = document.getElementById('verifySmsButton');
    const closeVerifyButton = document.getElementById('closeVerifyButton');
    var phoneNumber;
    var codeSent = false;
    $("#verifyForm").submit(()=>{
        return false;
    });
    function setUpPhoneVerify(phone) {
        phoneNumber = phone;
        verifyPhoneTextField.value = (0, $jPxhr.formatPhone)(phone);
        if (initialoffer != null) verifyTopLabel.innerText = 'EARN ' + initialamount + '% OFF ONE ORDER';
        if (referralid != null) verifyTopLabel.innerText = 'EARN ' + initialamount + '% OFFER FROM YOUR FRIEND';
        verifyModal.style.display = 'flex';
    }
    resendCodeButton.addEventListener('click', async ()=>{
        resetView();
    });
    verifySmsButton.addEventListener('click', async ()=>{
        if (codeSent === false) {
            phoneNumber = verifyPhoneTextField.value.replace(/\D/g, '');
            var error = '';
            if (phoneNumber.length != 10) error = 'Please enter full 10 digits';
            if (error != '') alert(error);
            else checkPhoneNumber(phoneNumber);
        } else {
            // verify with code
            const code = verifyPhoneTextField.value;
            var error = '';
            if (code.length != 6) error = 'Please enter 6 digit code sent in SMS';
            if (error != '') alert(error);
            else verifyPhoneNumber(phoneNumber, code);
        }
    });
    closeVerifyButton.addEventListener('click', async ()=>{
        verifyModal.style.display = 'none';
        (0, $cxph1.goToNextPage)('/profile');
    });
    async function verifyPhoneNumber(phone, code) {
        progressModal.style.display = 'flex';
        try {
            const status = await (0, $03cFT.default).Cloud.run('verifyTextCodeWeb', {
                'phone': phone,
                'code': code
            });
            if (status === 'approved') {
                const request = {
                    'phone': phoneNumber,
                    'initialamount': initialamount,
                    'referid': referralid,
                    'locationid': (0, $kcvY9.default)
                };
                await (0, $03cFT.default).Cloud.run('updateUserVerificationAndRefferal', request);
                const currentUser = (0, $03cFT.default).User.current();
                if (currentUser != null) await currentUser.fetch();
                (0, $cxph1.goToNextPage)('/profile');
            } else alert('Code failed please try again');
        } catch (e) {
            alert(e.message);
        }
        progressModal.style.display = 'none';
    }
    async function checkPhoneNumber(phone) {
        progressModal.style.display = 'flex';
        try {
            const available = await (0, $03cFT.default).Cloud.run('checkPhoneNumber', {
                "phone": phone
            });
            if (available == true) await sendCode(phone);
            else alert('Offer already redeemed by this phone number');
        } catch (e) {
            alert(e.message);
        }
        progressModal.style.display = 'none';
    }
    async function sendCode(phone) {
        const status = await (0, $03cFT.default).Cloud.run('sendTextVerificationWeb', {
            "phone": phone
        });
        if (status === "pending") {
            verifyPhoneTextField.value = '';
            verifyPhoneTextField.placeholder = 'Enter Code';
            verifyTopLabel.innerText = 'ENTER 6 DIGIT CODE';
            resendCodeButton.style.display = 'block';
            verifySmsButton.value = 'VERIFY';
            verifyPhoneTextField.focus();
            codeSent = true;
        } else alert('Code failed to send');
    }
    async function resetView() {
        verifyPhoneTextField.value = (0, $jPxhr.formatPhone)(phoneNumber);
        verifyTopLabel.innerText = 'TO RECEIVE THIS OFFER YOU MUST VERIY PHONE NUMBER VIA SMS';
        resendCodeButton.style.display = 'none';
        verifySmsButton.value = 'SEND SMS CODE';
        codeSent = false;
        if (initialoffer != null) verifyTopLabel.innerText = 'EARN ' + initialamount + '% OFF ONE ORDER';
        if (referralid != null) verifyTopLabel.innerText = 'EARN ' + initialamount + '% OFFER FROM YOUR FRIEND';
    }
});


//# sourceMappingURL=create-account.e6cd8d1b.js.map
